import form from '@/mixins/crud-form';
export default {
  mixins: [form],
  data: function data() {
    return {
      api: {
        detail: 'SMS_DETAIL',
        create: 'SMS_CREATE',
        update: 'SMS_UPDATE'
      },
      dialog: {
        width: '900px',
        height: '900px'
      }
    };
  },
  computed: {
    setting: function setting() {
      var _this = this;

      var h = this.$createElement;
      return [{
        prop: 'app_id',
        default: '',
        label: 'app_id',
        col: {
          span: 16
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.app_id,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "app_id", $$v);
              }
            }
          });
        }
      }, {
        prop: 'key',
        default: '',
        label: 'key',
        col: {
          span: 16
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.key,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "key", $$v);
              }
            }
          });
        }
      }, {
        prop: 'notify_value',
        default: '',
        label: '提醒值',
        col: {
          span: 16
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input-number", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.notify_value,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "notify_value", $$v);
              }
            }
          });
        }
      }];
    }
  }
};